// extracted by mini-css-extract-plugin
export var arrowIcon = "TextLink-module--arrow-icon--109db";
export var icon = "TextLink-module--icon--cde65";
export var link = "TextLink-module--link--20712";
export var linkText = "TextLink-module--linkText--64287";
export var reverse = "TextLink-module--reverse--6eb61";
export var underline = "TextLink-module--underline--41a26";
export var uppercase = "TextLink-module--uppercase--9007d";